import React, { useState } from 'react';
import axios from '../axios';
import { useNavigate } from 'react-router-dom';
import {Container, Form, FormBtn, FormCover, H3, MediumSpacing} from "../../styles";

const SemesterAdd = () => {
    const [year, setYear] = useState('');
    const [semester, setSemester] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        const newSemester = { year, semester };

        axios.post('/semesters/', newSemester)
            .then(response => {
                console.log(response.data);
                navigate('/semesters/'); // Redirect to the semesters list
            })
            .catch(error => {
                console.error("There was an error creating the semester!", error);
            });
    };

    return (
        <Container>
            <FormCover>
            <H3>Add Semester</H3>
                                <MediumSpacing/>

            <Form onSubmit={handleSubmit}>
                <div>
                    <label>Year:</label>
                    <br/>
                    <input
                        type="number"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        required
                    />
                </div>
                <MediumSpacing/>
                <div>
                    <label>Semester:</label>
                    <br/>
                    <input
                        type="number"
                        value={semester}
                        onChange={(e) => setSemester(e.target.value)}
                        required
                    />
                </div>
                <FormBtn type="submit">Add Semester</FormBtn>
            </Form>
        </FormCover>

        </Container>
    );
};

export default SemesterAdd;
